import axios from "axios";
import { isEmpty } from "lodash";
// import Cookies from "js-cookie";

const userDetails = localStorage.getItem("sessionUser");

const userInfo = !isEmpty(userDetails) ? JSON.parse(userDetails) : "";
console.log(userInfo, "userInfo");

//logged user details
const loggedUser = localStorage.getItem("loggedInUser");
const verifiedUserDetails = loggedUser ? JSON.parse(loggedUser) : "";
const verifiedToken =
  verifiedUserDetails &&
  verifiedUserDetails.data &&
  verifiedUserDetails.data.token !== undefined
    ? verifiedUserDetails.data.token
    : "";

const api = axios.create({
  // baseURL: "https://pmtrewards.mequalsvps.in",
  // baseURL: "https://pmtc4.mequalstech.com/api",
  // baseURL: "https://api.planmitrip.com",
  // baseURL:
  //   "https://bbd9-2401-4900-925a-b54a-cd63-79de-b07c-a364.ngrok-free.app",
  baseURL: "https://pmtuserapi.mequalsvps.in",
  // baseURL: "https://pmtrewards.mequalstech.com/api",

  headers: {
    Accept: "application/json",
    // Authorization: userInfoDetails.token
  },
});
if (verifiedToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${verifiedToken}`;
}

// api.interceptors.request.use(onRequest, null);

export function setAuthToken(authToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
}
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;

export async function get(url, config = {}) {
  return await api.get(url, { ...config }).then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return api
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return api
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await api.delete(url, { ...config }).then((response) => response.data);
}
